import { InfiniteData } from '@tanstack/react-query'
import { MessageRow, MessagesPage } from '../../../generated/api/chat-room'

export type RoomMessagesData = InfiniteData<MessagesPage, number>

const hasMessage = (data: RoomMessagesData, messageId: string): boolean =>
  data.pages.some((page) => page.items.some((item) => item.id === messageId))

export const insertMessage = (
  data: RoomMessagesData | undefined,
  row: MessageRow
): RoomMessagesData | undefined => {
  if (!data || data.pages.length === 0) return data
  if (hasMessage(data, row.id)) return data

  const [firstPage, ...rest] = data.pages
  return {
    ...data,
    pages: [{ ...firstPage, items: [row, ...firstPage.items] }, ...rest],
  }
}
